import { hasMessage, useI18n } from "../../i18n";

/**
 * 원리 태그 칩(SR-MDF-05) — 태그 키는 카탈로그(student.tags.*)에 있는 것만 보인다(자유 텍스트 0 · DR-02).
 */
export function TagChips({ tags, label }: { tags: readonly string[]; label: string }) {
  const { t, locale } = useI18n();
  const known = [...new Set(tags)].filter((k) => hasMessage(`student.tags.${k}`, locale));
  if (known.length === 0) return null;
  return (
    <ul className="pf-chips pf-tags" aria-label={label}>
      {known.map((k) => (
        <li key={k} className="pf-chip-static pf-chip-static--info" data-tag={k}>
          {t(`student.tags.${k}`)}
        </li>
      ))}
    </ul>
  );
}
